// extracted by css-extract-rspack-plugin
export default {"layout":"App_layout__POi9K","header":"App_header__oW4e0","hide":"App_hide__XSMvn","body":"App_body__sybST","main":"App_main__Hm6HW"};